export default {
    data: () => ({
        filters: {
            brands: [],
            brand_model: [],
            fuel_type: [],
            argerd: [],
            verd: [],
            ekinn: [],
            affinity: [],
            towing_capacity: [],
            girartegund: [],
            flokkar: [],
            other: [],
            vt: [],
            verdtilbod: false,
            category: [],
            sort: {
                field: "",
                order: ""
            },
            parking: false,
            companies: [],
            drif: [],
            notInCountry: false,
            k7: false,
            tire_size:[],
            rim_size:[],
            cylinders: [],
            color: [],
            doors: []
        },
        showRes: false,
        resultCount: 0,
        brands: [],
        brand_model: [],
        carsInSliders: [],
        fuel_type: [],
        extraType: true,
        flokkar: [],
        other: [],
        vehicle_type: [],
        categories: [],
        selected_filters_count: 0,
        isSub: 0,
        savedCars: false,
        subscriber: null,
        all: true,
        load: false,
        busy: false,
        oldCars: {},
        girartegund: [],
        ad: null,
        allAd: null,
        loadAd: false,
        // TODO: remove field after create logic
        mounted: false,
        oldCarsLoadedData: false,
        showMenuPosition: null,
        filtered: false,
        loadSliders: false
    }),
}